import { render, staticRenderFns } from "./AssistantMessage.vue?vue&type=template&id=c27dd5ba&scoped=true"
import script from "./AssistantMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMessage.vue?vue&type=script&lang=js"
import style0 from "./AssistantMessage.vue?vue&type=style&index=0&id=c27dd5ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27dd5ba",
  null
  
)

export default component.exports